<template>
  <el-dialog
    class="dialog-wrapper send-quarantine-dialog"
    visible
    :show-close="false"
    @close="abortQuarantine"
  >
    <ContentHeader
      slot="title"
      :title="$t('tableButtons.quarantine')"
    />
    <ValidationObserver
      ref="sendToQuarantineForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <el-row
          :gutter="20"
          type="flex"
          v-if="!apiCallStarted"
        >
          <el-col :span="24">
            <FormItem
              rules="required"
              :label="$t('quarantine.send.status')"
            >
              <el-select
                v-model="formData.reason"
                placeholder=""
              >
                <el-option
                  v-for="status in statuses"
                  :key="status.value"
                  :label="status.label"
                  :value="status.value"
                />
              </el-select>
            </FormItem>
          </el-col>
        </el-row>

        <el-row
          :gutter="20"
          type="flex"
          v-if="!apiCallStarted"
        >
          <el-col :span="24">
            <FormItem
              rules="required"
              :label="$t('quarantine.send.comment')"
            >
              <el-input
                type="textarea"
                v-model="formData.quarantineComment"
              />
            </FormItem>
          </el-col>
        </el-row>

        <BulkCall
          ref="progress"
          :function="quarantineApiSendQuarantine"
          :arguments="functionArguments"
          @completed="bulkCallCompleted"
        />

        <FormButtons>
          <el-button
            v-if="!apiCallStarted"
            type="secondary"
            @click.prevent="abortQuarantine"
          >
            {{ $t('quarantine.send.abort') }}
          </el-button>
          <el-button
            v-if="!apiCallStarted"
            type="primary"
            native-type="submit"
            :disabled="invalid || apiCallStarted"
            :loading="loading"
            @click.prevent="handleSubmit(sendToQuarantine)"
          >
            {{ $t('quarantine.send.confirm') }}
          </el-button>
          <el-button
            v-if="apiCallStarted && apiCallEnded"
            type="primary"
            @click.prevent="closeBulk"
          >
            {{ $t('global.close') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { quarantineApi } from '@/api';
  import FormItem from '@/components/FormItem.vue';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import {
    QUARANTINE_REASONS,
    QUARANTINE_REASONS_DESC,
  } from '@/config/constants';
  import BulkCall from '@/components/BulkCall.vue';

  const defaultData = {
    reason: 0,
    quarantineComment: '',
  };

  export default {
    name: 'SendToQuarantine',
    components: {
      FormItem,
      ContentHeader,
      FormButtons,
      BulkCall,
    },
    props: {
      sampleId: { type: Array, default: () => [] },
    },
    data() {
      return {
        formData: { ...defaultData },
        statuses: [
          {
            label: this.$t(
              `enums.quarantineReasons.${
                QUARANTINE_REASONS_DESC[QUARANTINE_REASONS.UNIDENTIFIED]
              }`
            ),
            value: QUARANTINE_REASONS.UNIDENTIFIED,
          },
          {
            label: this.$t(
              `enums.quarantineReasons.${
                QUARANTINE_REASONS_DESC[QUARANTINE_REASONS.NONCOMPLIANT]
              }`
            ),
            value: QUARANTINE_REASONS.NONCOMPLIANT,
          },
        ],
        apiCallStarted: false,
        apiCallEnded: false,
        loading: false,
      };
    },
    computed: {
      functionArguments() {
        return this.sampleId.map((id) => [id]);
      },
    },
    methods: {
      sendToQuarantine() {
        this.apiCallStarted = true;
        this.$refs.progress.run();
      },
      quarantineApiSendQuarantine(sampleId) {
        return quarantineApi.create(sampleId, this.formData);
      },
      abortQuarantine() {
        this.formData = { ...defaultData };
        this.$refs.sendToQuarantineForm.reset();
        this.$emit('dialogClose', { success: false });
      },
      closeBulk() {
        this.$emit('dialogClose', { success: true });
      },
      bulkCallCompleted(errors) {
        this.apiCallEnded = true;
        if (!errors) {
          this.closeBulk();
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('global.success'),
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  .send-quarantine-dialog {
    .el-dialog {
      width: 30%;
    }
  }
</style>
